<main class="manage">
    <form [formGroup]="holdingManageForm" class="form-validate">
        <div class="form-content">
            @if (holdings.length > 0) {
                <input-auto-complete class="input" label="support.seller-vacation.form.label.supplier" [options]="holdings" [control]="holdingNameControl" (onDeleteText)="disableControl(sellerNameControl)" />
                <input-auto-complete class="input" [options]="holdingsSellers" label="support.seller-vacation.form.label.seller"  [control]="sellerNameControl" (onDeleteText)="disableControl(sellerSubstituteNameControl)"/>
                <input-auto-complete class="input" [options]="holdingsSellersSubstitute" label="support.seller-vacation.form.label.substitute"  [control]="sellerSubstituteNameControl" (onDeleteText)="disableControl(endDateControl)"/>
                <input-date-component class="input" label="support.seller-vacation.form.label.end-date" [control]="endDateControl" [minDate]="minEndVacationDate"/>
            }
        </div>
        <footer>
            <button customButton styleType="primary" [outline]="true" iconName="x" label="elemento.generico-botao.cancelar" [isLoading]="false" (click)="close()"></button>
            <button customButton styleType="secondary" label="elemento.generico-botao.salvar" [isLoading]="false" (click)="save()"></button>
        </footer>
    </form>
</main>
